import { createTheme } from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#bb86fc",
    },
    secondary: {
      main: "#03dac6",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#1f1f1f",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
        contained: {
          color: "#ffffff",
          backgroundColor: "#bb86fc",
          '&:hover': {
            backgroundColor: "#9c66e5",
          },
        },
        outlined: {
          color: "#bb86fc",
          borderColor: "#bb86fc",
          '&:hover': {
            borderColor: "#bb86fc",
            color: "#bb86fc",
          },
        },
      },
    },    
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "white",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          "&.Mui-selected": {
            color: "white",
          },
        },
      },
    },
    // MuiModal: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(5px)",
    //       "& .MuiPaper-root": {
    //         backgroundColor: "#1e1e1e",
    //       },
    //     },
    //   },
    // },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#ffffff",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "#1e1e1e",
          color: "#ffffff",
        },
      },
    },
  },
});

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3f51b5",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f8f8f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#000000",
      secondary: "#4f4f4f",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
        contained: {
          color: "#ffffff",
          backgroundColor: "#3f51b5",
          '&:hover': {
            backgroundColor: "#303f9f",
          },
        },
        outlined: {
          color: "#3f51b5",
          borderColor: "#3f51b5",
          '&:hover': {
            borderColor: "#364aaf",
            color: "#364aaf",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "black",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          "&.Mui-selected": {
            color: "black",
          },
        },
      },
    },
    // MuiModal: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(5px)",
    //       "& .MuiPaper-root": {
    //         backgroundColor: "#ffffff",
    //       },
    //     },
    //   },
    // },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#000000",
        },
      },
    },
  },
});

export { darkTheme, lightTheme };
